import React, { type ReactNode } from "react";

interface Props {
  showSidebar?: boolean;
  sideBar?: ReactNode;
  showHeader?: boolean;
  header?: ReactNode;
  children?: ReactNode;
  previewMobile?: ReactNode;
}

export default function Layout(props: Props) {
  return (
    <div id="main-layout" className="w-100 flex-grow-1">
      <div id="k-main-container" className="k-main-container">
        {props.showHeader && (
          <div className="position-relative k-main-header">{props.header}</div>
        )}
        <div
          id="k-main-content"
          className="k-main-content d-flex flex-column flex-lg-row"
        >
          {props.showSidebar && props.sideBar}
          <div id="k-main-right" className="k-main-right">
            {props.children}
          </div>
          {props.previewMobile ? (
            <div className="k-main-preview-mobile">{props.previewMobile}</div>
          ) : null}
        </div>
      </div>
    </div>
  );
}
